import { ArrowLeft, ArrowRight } from '@mui/icons-material'
import {
  Box,
  Button,
  FormControl,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material'
import React from 'react'

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const CalendarDatePicker = ({ view, setView, setFocusDate, focusDate }) => {
  const handleChange = (inc) => {
    if (view === 'month')
      return setFocusDate((prev) => {
        const temp = new Date(prev)
        return new Date(temp.setMonth(temp.getMonth() + inc))
      })

    if (view === 'week')
      return setFocusDate((prev) => {
        const temp = new Date(prev)
        return new Date(temp.setDate(temp.getDate() + inc * 7))
      })

    if (view === 'day')
      return setFocusDate((prev) => {
        const temp = new Date(prev)
        return new Date(temp.setDate(temp.getDate() + inc * 1))
      })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
      }}
    >
      <Box
        sx={{
          fontWeight: 'bold',
          fontSize: '16px',
        }}
      >
        <IconButton onClick={() => handleChange(-1)}>
          <ArrowLeft />
        </IconButton>
        <IconButton onClick={() => handleChange(1)}>
          <ArrowRight />
        </IconButton>
        {monthNames[focusDate.getMonth()]} {focusDate.getFullYear()}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Button sx={{ mr: 2 }} onClick={() => setFocusDate(new Date())}>
          Today
        </Button>
        <FormControl margin='dense'>
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(e) => setView(e.target.value.toLowerCase())}
            color='primary'
          >
            {['Day', 'Week', 'Month'].map((type, i) => (
              <ToggleButton key={i} value={type.toLowerCase()}>
                {type}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </FormControl>
      </Box>
    </Box>
  )
}

export default CalendarDatePicker
